import { API } from "aws-amplify";

export interface CatalogAddress {
  addressId: string;
  state?: string;
  city?: string;
  postalCode?: string;
  defaultOption?: boolean;
}

// Onboarded test addresses a new customer can be created with.
export async function getCatalogAddresses(): Promise<CatalogAddress[]> {
  const response = await API.get("ApaqPortalAPI", "/address/get-addresses", {});
  return response?.addresses ?? [];
}

export function formatCatalogAddress(address: CatalogAddress): string {
  const { state, city, postalCode } = address;
  return [state, [city, postalCode].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");
}

export function getDefaultCatalogAddressId(addresses: CatalogAddress[]): string {
  // Fall back to the first address so the dropdown never shows blank.
  return (addresses.find((a) => a.defaultOption) ?? addresses[0])?.addressId ?? "";
}
